import React, { ReactNode, createContext, useContext } from "react";
import { FrontendConfiguration } from "../../model/config/FrontendConfiguration.js";

type ConfigState = {
  configuration: FrontendConfiguration;
};

const ConfigContext = createContext<ConfigState | undefined>(undefined);

type Props = {
  configuration: FrontendConfiguration;
  children: ReactNode;
};

/**
 * Frontend configuration provider.
 */
export const ConfigProvider = ({ children, configuration }: Props) => {
  const value: ConfigState = {
    configuration
  };

  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};

/**
 * Helper hook to access the frontend configuration.
 */
export const useConfiguration = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("The configuration context is not provided.");
  }
  return context.configuration;
};
